import React, { FC } from 'react'

import { IconInternationalProps } from './IconInternational.types'
import * as Styled from './styles/IconInternational.style'

import { nonThemeableRules } from '../../ruleSet'

const IconInternational: FC<IconInternationalProps> = ({
  size = nonThemeableRules.defaultSize as number as IconInternationalProps['size'],
  isResponsive = false,
}: IconInternationalProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M25.56 5.055C31.083 9.975 35 16.635 35 24c0 7.282-4.025 14.042-9.44 18.945m-3.12-37.89C16.917 9.975 13 16.635 13 24c0 7.282 4.025 14.042 9.44 18.945M24 43V5'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M38.568 11.797C34.25 14.902 29.45 17 24 17c-5.38 0-10.23-2.11-14.563-5.203m.003 24.406C13.75 33.096 18.555 31 24 31c5.382 0 10.23 2.11 14.565 5.203'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M5 24h38' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconInternational
